import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';

function BaggageTerms({ onHide }) {
  return (
    <Modal
      className="app-modal bag-terms-conditions-modal"
      size="lg"
      show
      onHide={onHide}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Prepaid Excess Baggage rates for International Connecting Flights
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="separator" />
      </Modal.Body>
    </Modal>
  );
}

BaggageTerms.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default BaggageTerms;
